import { escapeForCSV } from '../../../core/utils/download.js';
import { PieChartData } from '../types/pie-chart.config.js';

export function formatCsv(rawData: PieChartData) {
  const csvRows: string[] = ['category, value, unit'];
  const escapedUnit = escapeForCSV(rawData.unit);

  for (const slice of rawData.slices) {
    const sanitizedValue = escapeForCSV(slice.value);

    const sanitizedCategory = escapeForCSV(slice.category);

    const csvRow = [sanitizedCategory, sanitizedValue, escapedUnit].join(',');
    csvRows.push(csvRow);
  }

  return csvRows.join('\r\n');
}
